import { AppSider } from 'shared/UI/UIKit/Sider';
import { TableFilter } from 'common/TableFilter';
import { OrganizationsTable } from './Table/OrganizationsTable';
import { OrganizationsTableControls } from './Controls/Controls';
import { useOrganizations } from './Organizations/use-organizations';

export const Organizations = () => {
  const { state, methods } = useOrganizations();

  return (
    <>
      <OrganizationsTableControls
        columns={state.columns}
        visibleKeys={state.visibleKeys}
        setVisibleKeys={methods.setVisibleKeys}
        showSider={methods.showSider}
        filterCount={state.filterCount}
      />
      <OrganizationsTable
        loading={state.loading}
        dataSource={state.organizations}
        columns={state.filteredColumns}
        tableState={state.tableState}
        onChange={methods.onTableChange}
      />
      <AppSider
        title="Фильтры"
        isSiderVisible={state.siderVisible}
        submitBtnText="Применить"
        cancelBtnText="Сбросить всё"
        hideSider={methods.hideSider}
      >
        <TableFilter
          fields={state.filterFields}
          submitBtnText="Применить"
          resetBtnText="Сбросить всё"
          onSubmit={methods.onFilterChange}
          onClose={methods.hideSider}
          onLoadOptions={methods.onLoadFilterOptions}
          fieldsValue={state.filterState}
        />
      </AppSider>
    </>
  );
};
